import blankPage from "@/components/blankPage/index.vue";
export default [
  {
    name: "inventoryActivitiesIndex",
    path: "/talentInventory",
    component: blankPage,
    redirect: "inventoryActivities",
    meta: {
      title: "盘点活动",
    },
    children: [
      {
        name: "inventoryActivities",
        path: "inventoryActivities",
        component: () =>
          import("@/views/talentInventory/inventoryActivities.vue"),
        meta: {
          title: "盘点活动",
        },
      },
      {
        name: "inventorySchedule",
        path: "inventorySchedule",
        component: () =>
          import("@/views/talentInventory/inventorySchedule/index.vue"),
        meta: {
          title: "盘点详情",
          parentAuth: "/talentInventory/inventoryActivities",
        },
      },
      {
        name: "potentialDictionary",
        path: "potentialDictionary",
        component: () =>
          import("@/views/talentInventory/potentialDictionary.vue"),
        meta: {
          title: "潜力词典",
        },
      },
      {
        name: "teachingPlan",
        path: "teachingPlan",
        component: () =>
          import("@/views/talentInventory/teachingPlan/index.vue"),
        meta: {
          title: "带教计划",
        },
      },
      {
        name: "successorPlan",
        path: "successorPlan",
        component: () => import("@/views/talentInventory/successorPlan/index"),
        meta: {
          title: "接班人计划",
        },
      },
      {
        name: "offline360Interviews",
        path: "offline360Interviews",
        component: () =>
          import("@/views/talentInventory/offline360Interviews/index.vue"),
        meta: {
          title: "线下360访谈",
        },
      },
      {
        name: "qualityEvaluationReport",
        path: "qualityEvaluationReport",
        component: () =>
          import("@/views/talentInventory/qualityEvaluationReport/index.vue"),
        meta: {
          title: "素质测评报告",
        },
      },
      {
        name: "employeeEngagement",
        path: "employeeEngagement",
        component: () =>
          import("@/views/talentInventory/employeeEngagement/index.vue"),
        meta: {
          title: "员工敬业度报告",
        },
      },
      {
        name: "matureTalentSurvey",
        path: "matureTalentSurvey",
        component: () =>
          import("@/views/talentInventory/matureTalentSurvey/index.vue"),
        meta: {
          title: "成熟人才考察",
          replaceSameTab: true,
        },
      },
      {
        name: "professionalTeamDashboard",
        path: "professionalTeamDashboard",
        component: () =>
          import("@/views/talentInventory/professionalTeamDashboard/index.vue"),
        meta: {
          title: "专业梯队看板",
        },
      },
      {
        name: "managerPerformance",
        path: "managerPerformance",
        component: () =>
          import("@/views/talentInventory/managerPerformance/index.vue"),
        meta: {
          title: "管理者述职",
        },
      },
    ],
  },
];
